import { SHSearchBox } from "@components/design-systems";
import React from "react";
import { RootState, useAppDispatch } from "@redux/store";
import { updateModelScreenerFilters } from "@redux/slices/model-screener";
import { useSelector } from "react-redux";
import { ModelScreenerBasicFilters } from "@models/model-screener/entities/modelScreenerFilter";
import { MSDefaultDelayTimeMs } from "@pages/managed-accounts/model-screener/constant";

export const MSTableSearchBox = () => {
  const dispatch = useAppDispatch();
  const msFilters = useSelector(
    (state: RootState) => state.modelScreener.basicFilters,
  );

  const handleOnSearch = (value: string | null) => {
    const newFilters: ModelScreenerBasicFilters = {
      ...msFilters,
      searchValue: value,
    };

    dispatch(updateModelScreenerFilters({ basicFilter: newFilters }));
  };

  return (
    <SHSearchBox
      onChange={handleOnSearch}
      debounceTime={MSDefaultDelayTimeMs}
      placeholder="Search manager, series and model"
      isLoading={false}
    />
  );
};
